import { SchemaCRUD } from '@/components/crud/SchemaCRUD';

const Blockchains = () => {
	return (
		<SchemaCRUD
			entity="blockchains"
			title="Blockchains"
			description="Gerenciar redes blockchain suportadas"
			apiEndpoint="v1/admin/blockchains"
		/>
	);
};

export default Blockchains;
